import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { console_log, DataProvider } from 'src/providers/data/data';
import { CallapiService } from 'src/providers/rest/callapi.service';
import { DatepickerOptions } from 'ng2-datepicker';
import locale from 'date-fns/locale/ja';
import { getYear } from 'date-fns';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-contract-salecompany-edit',
  templateUrl: './salecompany-contract-edit.component.html',
  styleUrls: ['./salecompany-contract-edit.component.scss'],
})
export class SaleCompanyContractEditComponent implements OnInit {
  public uuid;
  public Corporate_Status;
  public Corporation_Form;
  public Company_Name;
  public Company_Name_Kana;
  public Post_Code;
  public Address_1;
  public Address_2;
  public Address_3;
  public TelePhone;
  public Email;
  public Last_Name;
  public Name;
  public Last_Name_Kana;
  public Name_Kana;
  public business_type;
  public BusinessType = [];
  public business_name;  
  public notKana = false;
  public notFirstnameKana = false;
  public notLastnameKana = false;
  public Business_Type_Name;
  public AppDate;
  public StartDate;
  public EndDate;
  public Staff_Post;
  public Staff_Position;
  public pdffile_name;
  public AcquiredInfo = [];
  public acquired_data = '';
  public AcquiredName = '';
  public AcquiredCode = '';
  public documentpdf;
  public Number_Off_Employees;


  constructor(
    private router: Router,
    private renderer: Renderer2,
    public data: DataProvider,
    private route: ActivatedRoute,
    public rest: CallapiService,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    protected datepipe: DatePipe,
  ) {
    this.BusinessType = [
      {code: "01", name: "農業・林業"},
      {code: "02", name: "漁業"},
      {code: "03", name: "鉱業，採石業，砂利，採取業"},
      {code: "04", name: "建設業"},
      {code: "05", name: "製造業"},
      {code: "06", name: "電気・ガス・熱供給・水道業"},
      {code: "07", name: "情報通信業"},
      {code: "08", name: "運輸業，郵便業"},
      {code: "09", name: "卸売業，小売業"},
      {code: "10", name: "金融業，保険業"},
      {code: "11", name: "不動産業，物品賃貸業"},
      {code: "12", name: "学術研究，専門・技術サービス業"},
      {code: "13", name: "宿泊業，飲食サービス業"},
      {code: "14", name: "生活関連サービス業，娯楽業"},
      {code: "15", name: "教育，学習支援業"},
      {code: "16", name: "医療，福祉"},
      {code: "17", name: "複合サービス事業"},
      {code: "18", name: "サービス業"},
      {code: "19", name: "公務"},
      {code: "20", name: "分類不能の産業"},
    ];
  }

  ngOnInit() {
    this.data.menuPageTitle = 'wf-salecompany-contract-list';
    this.uuid = this.route.snapshot.paramMap.get('uuid');
    this.widthChanger('main-header', 942);
    this.spinner.show();
    this.rest.Get_Screenauth(this.data.uuid).subscribe(
      (res) => {
        var pages = res.data;
        const page = pages.find(page => page.pagename === 'wf-salecompany-contract-edit');
        var bool = page ? page.auth === "F" : false;
        if (!bool) {
          this.router.navigate(['/']);
        }
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
    this.rest.Get_SaleCompanyId(this.data.uuid, this.uuid).subscribe(
      (res) => {
        console_log(res);
        this.Corporate_Status = res.data.corporate_status;
        this.Corporation_Form = res.data.corporation_form;
        this.Company_Name = res.data.company_name;
        this.Company_Name_Kana = res.data.company_name_kana;
        this.Post_Code = res.data.postcode;
        this.Address_1 = res.data.address_1;
        this.Address_2 = res.data.address_2;
        this.Address_3 = res.data.address_3;
        this.TelePhone = res.data.tel;
        this.Email = res.data.mail_address;
        this.Last_Name = res.data.staff_last_name;
        this.Name = res.data.staff_first_name;
        this.Last_Name_Kana = res.data.staff_last_name_kana;
        this.Name_Kana = res.data.staff_first_name_kana;
        this.business_type = res.data.business_type.length == 1 ? '0' + res.data.business_type : res.data.business_type;
        this.AcquiredName = res.data.acquired_name;
        // this.changeType(this.Corporation_Form);
        this.Staff_Position = res.data.staff_position;
        this.Staff_Post = res.data.staff_post;
        if(res.data.app_date != ''){
          this.AppDate = new Date(res.data.app_date);
        }
        if(res.data.start_date != ''){
          let newStartDate =  new Date(res.data.start_date);
          this.StartDate = newStartDate;
        }
        if(res.data.end_date != ''){
          let newEndDate =  new Date(res.data.end_date);
          this.EndDate =  newEndDate;
        }
        this.Number_Off_Employees = res.data.users;

        this.spinner.hide();
        this.rest.Get_AcquiredMaster(this.data.uuid).subscribe(
          (res) => {
            this.AcquiredInfo = res.data.AcquiredInfo;
            for(let i = 0; i < this.AcquiredInfo.length; i++){
              if(this.AcquiredInfo[i].acquired_name == this.AcquiredName){
                this.acquired_data = this.AcquiredInfo[i].acquired_code + ':' +  this.AcquiredName;
              }
            }
          },
          (err) => { }
        );
      },
      (err) => {
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
      }
    );
  }
  getBusinessTypeName(code) {
    const business = this.BusinessType.find(b => b.code === code);
    return business ? business.name : '';
  }
  onKey(data) {
    this.rest.ZipCode(data).subscribe((res) => {
      if (res.results) {
        this.Address_1 =
          res.results[0].address1 +
          res.results[0].address2 +
          res.results[0].address3;
      }
    });
  }
  selectCorporation(id) {
    this.Corporate_Status = id;
  }
  // changeType(type) {
  //   this.Corporation_Form = type;
  //   if (type == '1') {
  //     document.getElementById('type1').classList.remove('btn-box-grey');
  //     document.getElementById('type1').classList.add('btn-box');
  //     document.getElementById('type2').classList.remove('btn-box');
  //     document.getElementById('type2').classList.add('btn-box-grey');
  //     document.getElementById('type3').classList.remove('btn-box');
  //     document.getElementById('type3').classList.add('btn-box-grey');
  //   } else if (type == '2') {
  //     document.getElementById('type2').classList.remove('btn-box-grey');
  //     document.getElementById('type2').classList.add('btn-box');
  //     document.getElementById('type1').classList.remove('btn-box');
  //     document.getElementById('type1').classList.add('btn-box-grey');
  //     document.getElementById('type3').classList.remove('btn-box');
  //     document.getElementById('type3').classList.add('btn-box-grey');
  //   } else {
  //     document.getElementById('type3').classList.remove('btn-box-grey');
  //     document.getElementById('type3').classList.add('btn-box');
  //     document.getElementById('type2').classList.remove('btn-box');
  //     document.getElementById('type2').classList.add('btn-box-grey');
  //     document.getElementById('type1').classList.remove('btn-box');
  //     document.getElementById('type1').classList.add('btn-box-grey');
  //   }
  // }

  back(id) {
    if (id == 1) {
      this.router.navigate(['/wf-salecompany-contract-detail', { uuid: this.uuid }]);
    } else {
      document.getElementById('confirm').style.display = 'none';
      document.getElementById('edit').style.display = 'block';
      this.widthChanger('main-header', 942);
    }
  }
  
  dataValidation() {
    let err = false;
    let errTxt = '';
    let Number = /^-?\d*$/;
    if (this.notFirstnameKana && this.Name_Kana !== null && this.Name_Kana !== '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_NOT_KITAGANA_FIRSTNAME')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Name_Kana == null || this.Name_Kana == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_KITAGANA_FIRSTNAME')
        .subscribe((res) => (errTxt = res));
    }
    if (this.notLastnameKana && this.Last_Name_Kana !== null && this.Last_Name_Kana !== '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_NOT_KITAGANA_LASTNAME')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Last_Name_Kana == null || this.Last_Name_Kana == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_KITAGANA_LASTNAME')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Name == null || this.Name == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_FIRSTNAME')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Last_Name == null || this.Last_Name == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_LASTNAME')
        .subscribe((res) => (errTxt = res));
    }
    if (this.business_type == null || this.business_type == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_BUSINESS_TYPE')
        .subscribe((res) => (errTxt = res));
    }
    if (!this.validateEmail(this.Email)) {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_MAIL')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Email == null || this.Email == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_MAIL')
        .subscribe((res) => (errTxt = res));
    }
    if (this.TelePhone == null || this.TelePhone == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_TELEPHONE')
        .subscribe((res) => (errTxt = res));
    } else if (this.TelePhone != "" && !Number.test(this.TelePhone)) {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_TELEPHONE_NO_NUMBER')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Address_2 == null || this.Address_2 == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_ADDRESS_2')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Address_1 == null || this.Address_1 == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_ADDRESS_1')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Post_Code == null || this.Post_Code == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_POSTCODE')
        .subscribe((res) => (errTxt = res));
    } else if (this.Post_Code != "" && !Number.test(this.Post_Code)) {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_POSTCODE_NO_NUMBER')
        .subscribe((res) => (errTxt = res));
    }
    if (this.notKana === true && this.Company_Name_Kana !== null && this.Company_Name_Kana !== '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_COMPANY_NAME_NOT_KANA')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Company_Name_Kana == null || this.Company_Name_Kana == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_COMPANY_NAME_KANA')
        .subscribe((res) => (errTxt = res));
    }
    if (this.Company_Name == null || this.Company_Name == '') {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_COMPANY_NAME')
        .subscribe((res) => (errTxt = res));
    }
    if (err) {
      document.getElementById('error').innerHTML = errTxt;
      document.getElementById('error').style.display = 'block';
      return false;
    }
    return true;
  }

  change() {
    document.getElementById('error').style.display = 'none';
  }

  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
    for (let i = 0; i < headers.length; i++) {
      const header = headers[i] as HTMLElement;

      header.style.minWidth = width.toString() + 'px';
    }
  }

  input() {
    if (this.dataValidation() == false) {
      return true;
    } else {
      this.Business_Type_Name = this.getBusinessTypeName(this.business_type);
      document.getElementById('confirm').style.display = 'block';
      document.getElementById('edit').style.display = 'none';
      document.getElementById('confirm').classList.remove('row1');
      document.getElementById('edit').classList.add('row');
      this.widthChanger('main-header', 752);
    }
  }

  confirm() {
    this.spinner.show();
    this.StartDate = this.datepipe.transform(this.StartDate, 'yyyy/MM/dd');
    this.EndDate = this.datepipe.transform(this.EndDate, 'yyyy/MM/dd');
    this.AppDate = this.datepipe.transform(this.AppDate, 'yyyy/MM/dd');
    var acquiredData = this.acquired_data.split(":");
    let Acquired_Company_Code = acquiredData[0];
    this.rest.Update_SaleCompany(
      this.data.uuid,
      this.uuid,
      this.EndDate,
      this.Corporate_Status,
      this.Company_Name,
      this.Company_Name_Kana,
      this.Post_Code,
      this.Address_1,
      this.Address_2,
      this.Address_3,
      this.TelePhone,
      // this.Email,
      this.business_type,
      this.Last_Name,
      this.Name,
      this.Last_Name_Kana,
      this.Name_Kana,
      this.Staff_Post,
      this.Staff_Position,
      Number(this.Number_Off_Employees),
      this.Corporation_Form,
      Acquired_Company_Code,
    ).subscribe(
      (res) => {
        // console_log(res);
        // this.spinner.hide();
        // this.router.navigate(['/wf-salecompany-edit-comp']);
        if (window.IMAGE_RESULT) {
          this.rest.Upload_Regcertificates(this.uuid, this.data.uuid, window.IMAGE_RESULT).subscribe(
            (res) => {
              console_log(res);
              this.spinner.hide();
              this.router.navigate(['/wf-salecompany-edit-comp']);
            },
            (err) => {
              if (err.error.error) {
                this.spinner.hide();
                this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
              } else {
                this.spinner.hide();
                this.router.navigate(['/wf-contract-err', { code: 'ERR_PDF' }]);
              }
            }
          );
        } else {
          this.spinner.hide();
          this.router.navigate(['/wf-salecompany-edit-comp']);
        }
      },
      (err) => {

        if (err.error.error) {
          this.spinner.hide();
          this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
        } else {
          this.spinner.hide();
          this.router.navigate(['/wf-contract-err', { code: 'ERR_PDF' }]);
        }
      }
    );
  }

  onKeyKana(katakana) {
    if (!this.isKana(katakana) || katakana.includes('・')) {
      this.notKana = true;
    } else {
      this.notKana = false;
    }
  }

  onKeyLastNameKana(katakana) {
    if (!this.isKana(katakana) || katakana.includes('・')) {
      this.notLastnameKana = true;
    } else {
      this.notLastnameKana = false;
    }
  }

  onKeyNameKana(katakana) {
    if (!this.isKana(katakana) || katakana.includes('・')) {
      this.notFirstnameKana = true;
    } else {
      this.notFirstnameKana = false;
    }
  }

  isKana(ch) {
    let k = 0;
    for (let i = 0; i < ch.length; i++) {
      if (ch[i] >= "\u30a0" && ch[i] <= "\u30ff") {
        k++;
      }
    }
    if (k == ch.length) {
      return true;
    }
    return false;
  }
  
  validateEmail(mail) {
    var reg = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
    return reg.test(mail);
  }

  @ViewChild('date1') date1: ElementRef;
  @ViewChild('date2') date2: ElementRef;
  @ViewChild('date3') date3: ElementRef;
  options: DatepickerOptions = {
    minYear: getYear(new Date()) - 30, // minimum available and selectable year
    maxYear: getYear(new Date()) + 30, // maximum available and selectable year
    placeholder: '', // placeholder in case date model is null | undefined, example: 'Please pick a date'
    format: 'yyyy/MM/dd', // date format to display in input
    formatTitle: 'yyyy' + '年' + 'MM' + '月',
    formatDays: 'EEEEE',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: locale, // date-fns locale
    position: 'bottom',
    inputClass: '', // custom input CSS class to be applied
    calendarClass: 'datepicker-default', // custom datepicker calendar CSS class to be applied
    scrollBarColor: '#E10800', // in case you customize you theme, here you define scroll bar color
  };
  // resetDate(id) {
  //   if (id == 1) {
  //     if (this.AppDate != '') {
  //       this.date1['displayValue'] = '';
  //       this.AppDate = '';
  //       if (this.AppDate == '') {
  //         document.getElementById('clear1').style.display = 'none';
  //       }
  //     }
  //   } else if (id == 2) {
  //     if (this.StartDate != '') {
  //       this.date2['displayValue'] = '';
  //       this.StartDate = '';
  //       if (this.StartDate == '') {
  //         document.getElementById('clear2').style.display = 'none';
  //       }
  //     }
  //   } else if (id == 3) {
  //     if (this.EndDate != '') {
  //       this.date2['displayValue'] = '';
  //       this.EndDate = '';
  //       if (this.EndDate == '') {
  //         document.getElementById('clear2').style.display = 'none';
  //       }
  //     }
  //   }
  // }

  Calendar(id) {
    if (id == 1) {
      if (this.AppDate != '') {
        // document.getElementById('clear1').style.display = 'block';
      } else {
        // document.getElementById('clear1').style.display = 'none';
      }
    } else if(id == 2){
      if (this.StartDate != '') {
        // document.getElementById('clear2').style.display = 'block';
      } else if (this.StartDate == '') {
        // document.getElementById('clear2').style.display = 'none';
      }

    } else if (id == 3){
      if (this.EndDate != '') {
        // document.getElementById('clear2').style.display = 'block';
      } else if (this.EndDate == '') {
        // document.getElementById('clear2').style.display = 'none';
      }
    }
  }
  upload(event: Event) {
    const self: SaleCompanyContractEditComponent = this;
    const reader: FileReader = new FileReader();
    reader.onload = function () {
      var pdf_string = reader.result.toString();
      var pdf_binary = pdf_string.split('data:application/pdf;base64,');
      window.IMAGE_RESULT = pdf_binary[1];
    };
    const element: HTMLInputElement = <HTMLInputElement>event.srcElement;
    if (element.files.length > 0) {
      reader.readAsDataURL(element.files[0]);
      this.pdffile_name = element.files[0].name;
    }
    element.value = '';
  }
  selectPDF() {
    const input: HTMLElement = document.getElementById('pdffile');
    input.click();
  }
  pdf_download(){
    this.rest
      .Download_Regcertificates(this.data.uuid, this.uuid)
      .subscribe((res) => {
        if (res.code == 'S000001') {
          this.documentpdf = res.data.s3url;
          window.open(this.documentpdf, '_blank', '');
        }
      },
      (err) => {
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
      }
      );
  }
}